import DashboardCard from "./DashboardCard";
import { useSelector } from "react-redux";
import MyTasksLoader from "./my-tasks/MyTasksLoader";
import TasksPreview from "./my-tasks/TasksPreview";
import TasksList from "./my-tasks/TasksList";
import useFetchTaskInfo from "../../hooks/api/useFetchTaskInfo";
import { BsClipboard2Check } from "react-icons/bs";

function MyTasks() {
  const {
    dashboard: { taskInfoStatus, taskInfoError },
  } = useSelector((state) => state);

  useFetchTaskInfo();

  return (
    <DashboardCard
      title="My Tasks"
      // open={window.innerWidth > 768}
      titleIcon={<BsClipboard2Check />}
      preview={<TasksPreview />}
      type="myTasks"
    >
      {taskInfoStatus === "loading" && <MyTasksLoader />}

      {taskInfoStatus === "success" && <TasksList />}
    </DashboardCard>
  );
}

export default MyTasks;
